"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLateFeesApplyDate;
// Returns a the date late fees start being applied
// If there are no divisions charging late fees, eg a standalone Div 4,
// or the date has been set to after the end of the competition then returns null

function getLateFeesApplyDate(comp) {
  if (!comp.competitionDivisions.filter(d => d.lateFee > 0).length) return null;
  const dates = comp.competitionDays.map(d => d.dayDate).sort();
  if (!dates.length) return null;
  const lastDate = dates[dates.length - 1];
  if (comp.lateFeesDueDate > lastDate) return null;
  return comp.lateFeesDueDate;
}